import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import 'bootstrap/js/src/tooltip'

EventBus.subscribe('run-modules', () => {
 
    const elements = jQuery('.apply-tooltip')
    if (elements.length === 0) {
        return
    }
    
    elements.tooltip()

})